import type { EntrepriseFiche } from "./models.js";

const PLAN_DURATION_WORDS: Record<string, number> = {
  un: 1,
  une: 1,
  deux: 2,
  trois: 3,
  quatre: 4,
  cinq: 5,
  six: 6,
  sept: 7,
  huit: 8,
  neuf: 9,
  dix: 10,
  onze: 11,
  douze: 12,
  treize: 13,
  quatorze: 14,
  quinze: 15,
  seize: 16,
  "dix-sept": 17,
  "dix-huit": 18,
  "dix-neuf": 19,
  vingt: 20,
};

const PLAN_DURATION = /durée du plan (?:de )?(\d+|[a-z-]+) (ans|années|an|année|mois)/i;

export const hasOngoingCollectiveProcedure = (
  fiche: Pick<EntrepriseFiche, "procedure_collective_en_cours" | "procedures_collectives">,
  today = new Date().toISOString().slice(0, 10),
): boolean | null => {
  if (fiche.procedure_collective_en_cours === false) return false;
  if (!fiche.procedures_collectives) return fiche.procedure_collective_en_cours ?? null;

  return fiche.procedures_collectives.some((procedure) => {
    if (procedure.date_fin) return procedure.date_fin >= today;

    let planEnd: string | undefined;
    const publications = [...(procedure.publications_bodacc ?? [])].sort((a, b) =>
      (a.date ?? "").localeCompare(b.date ?? ""),
    );
    for (const publication of publications) {
      const match = PLAN_DURATION.exec(
        `${publication.nature ?? ""} ${publication.complement_jugement ?? ""}`,
      );
      if (!match?.[1] || !match[2]) continue;
      const count = PLAN_DURATION_WORDS[match[1].toLowerCase()] ?? parseInt(match[1], 10);
      if (!count) continue;
      const start = publication.date_jugement ?? publication.date;
      if (!start) continue;
      const [year, month, day] = start.split("-").map(Number);
      if (!year || !month || !day) continue;
      const date = new Date(Date.UTC(year, month - 1, day));
      if (match[2].startsWith("mois")) date.setUTCMonth(date.getUTCMonth() + count);
      else date.setUTCFullYear(date.getUTCFullYear() + count);
      planEnd = date.toISOString().slice(0, 10);
    }
    if (planEnd) return planEnd >= today;
    return true;
  });
};
